export default "__VITE_ASSET__DLb1BriQ__"